// extracted by mini-css-extract-plugin
export default {"test":"AdminCharts_test__MZVjn"};